import { useContext, useState } from "react"

import getVideo from "../services/getVideo"

import { AuthContext } from "../contexts/auth"
import postVideo from "../services/postVideo"
import { useNavigate } from "react-router-dom"
import toast from "react-hot-toast"
import putVideo from "../services/putVideo"
import getServices from "../services/getServices"

const useVideoState = () => {

    const { signOut } = useContext(AuthContext)

    const [submit, setSubmit] = useState(false)
    const [video, setVideo] = useState(null)
    
    const [nome, setNome] = useState('')
    const [nomeCurso, setNomeCurso] = useState('')
    const [sequencia, setSequencia] = useState('')
    const [linkvideo, setLinkvideo] = useState('')
    const [descricao, setDescricao] = useState('')
    const [cursos, setCurso] = useState(null)
    const [pesquisa, setPesquisa] = useState('')    

    const [listaColaboradorViu, setListaColaboradorViu] = useState(null)

    const navigate = useNavigate()    

    const _getVideo = async (id)=>{
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getVideo(`admin/video/${id}/`)
        if (result.type === 'success'){
            setNome(result.data.name)
            setDescricao(result.data.descricao)
            setLinkvideo(result.data.link_video)
            setSequencia(result.data.sequencia)
            
            setVideo(result.data)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        else if (result.data?.detail === 'Não encontrado.'){
            toast.error(result.data?.detail)
            navigate(`/gestor/curso/${cursos}/videos`) 
        }
        setSubmit(false)
    }

    const _getColaboradorViu = async (id)=>{
        if (submit){
            return;
        }
        setSubmit(true)
        
        let result = await getServices(`admin/cursos/videovisto/${id}/`)
        if (result.type === 'success'){
            setNome(result.data[0].videos.name)
            setNomeCurso(result.data[0].videos.cursos)
            setListaColaboradorViu(result.data)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        else if (result.data?.detail === 'Não encontrado.'){
            toast.error(result.data?.detail)
            navigate(`/gestor/curso/${cursos}/videos`) 
        }
        setSubmit(false)
    }

    const validaCampos = () => {
        let nome_video = false;
        let descricao_tamanho = false;
        
        if (nome !== '') {
            nome_video = true;
        } else {
            toast.error('O campo nome não pode ser em branco.')
        }

        if (descricao === '') {
            toast.error('O campo descricao não pode ser em branco.')
        } 
        else if (descricao.length > 250) {
            toast.error(`O campo descrição não pode ter mais de 250 caracteres. Ele possui ${descricao.length} caracteres.`)
        } else {
            descricao_tamanho = true;
        }
        
        return {
            nome_video: nome_video, 
            descricao_tamanho: descricao_tamanho
        }
    }

    const _postVideo = async ()=>{
        if (submit){
            return;
        }
        setSubmit(true)

        let json = {
            name: nome,
            sequencia: sequencia,
            link_video: linkvideo,
            descricao: descricao,
            cursos: cursos            
        }
         
        let { nome_video, descricao_tamanho } = validaCampos();
       
        if (nome_video && descricao_tamanho){
            let result = await postVideo('admin/videos/',json)
            

            if (result.type === 'success'){
                if (result.data?.status){
                    result.data?.status.forEach((mensagem)=>{
                        toast.error(mensagem)
                    })
                }
                else{
    
                    navigate(`/gestor/curso/${cursos}/videos`)  
                }
            }
            else if (result.data?.code === 'token_not_valid'){
                signOut()
            }
        }
        setSubmit(false)        

    }

    const _putVideo = async (id)=>{
        if (submit){
            return;
        }
        setSubmit(true)

        let json = {
            ...video, 
            name: nome,
            sequencia: sequencia,
            link_video: linkvideo,
            descricao: descricao,            
        }

        let { nome_video, descricao_tamanho } = validaCampos();
        
        
        if (nome_video, descricao_tamanho){

            let result = await putVideo(`admin/video/${id}/`,json)
            if (result.type === 'success'){
                if (result.data?.status){
                    result.data?.status.forEach((mensagem)=>{
                        toast.error(mensagem)
                    })
                }
                else{
                    navigate(`/gestor/curso/${cursos}/videos`)
                }
            }
            else if (result.data?.code === 'token_not_valid'){
                signOut()
            }
        }
        setSubmit(false)        

    }

    return {
        submit: {value: submit, set: _getVideo},
        video:{value:video,set:setVideo}, 
        listaColaboradorViu:{value:listaColaboradorViu,set:_getColaboradorViu}, 
        pesquisa: {value: pesquisa, set:setPesquisa},                
        nome:{value:nome,set:setNome}, 
        sequencia:{value:sequencia, set:setSequencia},
        linkvideo:{value:linkvideo, set:setLinkvideo},
        descricao:{value:descricao, set:setDescricao},
        nomeCurso:{value:nomeCurso, set:setNomeCurso},
        cursos:{value:cursos, set:setCurso},
        videoPost:{value:()=>{console.log('não implementado')},set:_postVideo},
        videoPut:{value:()=>{console.log('não implementado')},set:_putVideo},        
    }
}

export default useVideoState;